import { combineReducers } from 'redux';
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _without from 'lodash/without';
import _mapValues from 'lodash/mapValues';
import _union from 'lodash/union';
import _pickBy from 'lodash/pickBy';
import createGroup from './modules/createGroup/reducer';

import {
  REQUEST_WORKFORCE_TYPES,
  RECEIVE_WORKFORCE_TYPES,
  REPORT_WORKFORCE_TYPES_REQUEST_ERROR,
  SELECT_WORKFORCE_TYPE,
  FILTER_WORKFORCE_TYPE_DATA,
  SELECT_ALL_WORKFORCE_TYPES,
  DESELECT_ALL_WORKFORCE_TYPES,
  RECEIVE_WORKFORCE_TYPES_DATA,
} from './actions';

const initialState = {
  pending: false,
  chunks: {},
  selected: [],
  items: [],
  filteredChunks: {},
  filter: '',
  error: null,
  typesData: {},
};

const filterChunks = (chunks, filterHolder = '') => {
  let filteredChunks = chunks;
  const filter = filterHolder.replace(/[^a-zA-Z0-9 ]/g, '');

  if (filter !== '') {
    filteredChunks = _pickBy(chunks, chunk => {
      const rgx = new RegExp(`(${filter})`, 'gi');

      return rgx.test(chunk.name);
    });
  }
  const items = Object.keys(filteredChunks);

  return { filteredChunks, items };
};

const fields = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_WORKFORCE_TYPES:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case RECEIVE_WORKFORCE_TYPES:
      return {
        ...state,
        chunks: action.value,
        selected: [],
        filteredChunks: action.value,
        items: _keys(action.value),
        pending: false,
        error: null,
      };

    case RECEIVE_WORKFORCE_TYPES_DATA:
      return {
        ...state,
        typesData: action.value,
      };

    case FILTER_WORKFORCE_TYPE_DATA:
      return {
        ...state,
        ...filterChunks(state.chunks, action.payload),
        filter: action.payload,
      };

    case REPORT_WORKFORCE_TYPES_REQUEST_ERROR:
      return {
        pending: false,
        error: action.err,
      };

    case SELECT_WORKFORCE_TYPE: {
      const prevState = state.filteredChunks[action.key].selected;
      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          [action.key]: {
            ...state.filteredChunks[action.key],
            selected: !prevState,
          },
        },
        selected:
          prevState === true
            ? _without(state.selected, action.key)
            : state.selected.concat(action.key),
      };
    }

    case SELECT_ALL_WORKFORCE_TYPES: {
      const filteredChunks = _pick(state.chunks, state.items);
      const selectedChunks = _mapValues(filteredChunks, chunk => ({
        ...chunk,
        selected: !chunk.default,
      }));
      const selected = _union(
        state.selected,
        Object.keys(filteredChunks).filter(chunk => chunk !== 'default'),
      );

      return {
        ...state,
        filteredChunks: {
          ...state.chunks,
          ...selectedChunks,
        },
        selected,
        selectAll: true,
      };
    }

    case DESELECT_ALL_WORKFORCE_TYPES:
      return {
        ...state,
        filteredChunks: _mapValues(state.chunks, chunk => ({
          ...chunk,
          selected: false,
        })),
        selected: [],
        selectAll: false,
      };

    default:
      return state;
  }
};

export default combineReducers({
  data: fields,
  createGroup,
});
